// extracted by mini-css-extract-plugin
export default {"container":"eventcity_container__6cSaY","wrapper":"eventcity_wrapper__wQzUo","title":"eventcity_title__bbvrR","content":"eventcity_content__fFE2N"};